var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#B4B9C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.61327C6 7.22846 6.13514 6.911 6.40541 6.66089C6.67567 6.41076 7.02703 6.28571 7.45946 6.28571C7.88417 6.28571 8.2278 6.40883 8.49035 6.65511C8.76061 6.90908 8.89575 7.24 8.89575 7.6479C8.89575 8.01731 8.76448 8.32514 8.50193 8.57142C8.23166 8.82539 7.87645 8.95237 7.43629 8.95237H7.42471C7 8.95237 6.65637 8.82539 6.39382 8.57142C6.13127 8.31745 6 7.99806 6 7.61327ZM6.15058 17.7143V10.0029H8.72201V17.7143H6.15058ZM10.1467 17.7143H12.7181V13.4084C12.7181 13.139 12.749 12.9312 12.8108 12.785C12.9189 12.5233 13.083 12.302 13.3031 12.1212C13.5232 11.9403 13.7992 11.8499 14.1313 11.8499C14.9961 11.8499 15.4286 12.431 15.4286 13.5931V17.7143H18V13.2929C18 12.1539 17.7297 11.29 17.1892 10.7013C16.6486 10.1125 15.9344 9.81817 15.0463 9.81817C14.0502 9.81817 13.2741 10.2453 12.7181 11.0996V11.1226H12.7066L12.7181 11.0996V10.0029H10.1467C10.1622 10.2491 10.1699 11.0149 10.1699 12.3001C10.1699 13.5854 10.1622 15.3901 10.1467 17.7143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.33d406a5638006080fb152a792a58d46.svg";
export { ForwardRef as ReactComponent };